/*
 * Copyright (c) 2020.
 * Simon
 */

import React, {Component} from 'react';
import {Modal} from 'reactstrap';

class OverlayLoadingModal extends Component {
    constructor(props) {
        super(props);

        OverlayLoadingModal.__singletonRef = this;

        this.state = {
            isOpen: false,
        };
    }

    toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen,
        });
    };

    static showOverlayLoading() {
        OverlayLoadingModal.__singletonRef._show();
    }

    _show() {
        this.setState({
            isOpen: true,
        });
    }

    static hideOverlayLoading() {
        OverlayLoadingModal.__singletonRef._hide();
    }

    _hide() {
        this.setState({
            isOpen: false,
        });
    }

    render() {
        return (
            <span>
                <Modal
                    onEnter={this.onEnter}
                    toggle={this.toggle}
                    isOpen={this.state.isOpen}
                    size='sm'
                >
                    Loading
                </Modal>
            </span>
        );
    }
}


export default OverlayLoadingModal;
